// Text for the 'spaghetti' world: its name on the map, the level titles and the comic word in the scene, per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Spaghettiland',
    scene: { slurp: 'SLURP!' },
    levels: {
      'tomato-push': { title: 'Tomaten skubber' },
      'snip': { title: 'Klip!' },
      'rope-bridge': { title: 'Hængebro' },
      'long-string': { title: 'Lang snor' },
      'high-swing': { title: 'Højt sving' },
      'let-go-mid-swing': { title: 'Slip i svinget' },
      'too-far': { title: 'For langt' },
      'which-way': { title: 'Hvilken vej' },
      'up-and-over': { title: 'Op og over' },
      'pass-it-on': { title: 'Giv videre' },
      'push-over-the-bridge': { title: 'Skub over broen' },
      'cheese-catapult': { title: 'Ostekatapult' },
      'let-go-and-bridge': { title: 'Slip og bro' },
      'push-bridge-hop': { title: 'Skub, bro og hop' },
      'master-chef': { title: 'Mesterkokken' },
    },
  },
  en: {
    name: 'Spaghetti land',
    scene: { slurp: 'SLURP!' },
    levels: {
      'tomato-push': { title: 'The tomato pushes' },
      'snip': { title: 'Snip!' },
      'rope-bridge': { title: 'Rope bridge' },
      'long-string': { title: 'Long string' },
      'high-swing': { title: 'High swing' },
      'let-go-mid-swing': { title: 'Let go mid-swing' },
      'too-far': { title: 'Too far' },
      'which-way': { title: 'Which way?' },
      'up-and-over': { title: 'Up and over' },
      'pass-it-on': { title: 'Pass it on' },
      'push-over-the-bridge': { title: 'Push over the bridge' },
      'cheese-catapult': { title: 'Cheese catapult' },
      'let-go-and-bridge': { title: 'Let go and bridge' },
      'push-bridge-hop': { title: 'Push, bridge and hop' },
      'master-chef': { title: 'The master chef' },
    },
  },
});
